import { createApiClient, RequestError } from "@pagemates/shared/client";

import { noteServerVersion } from "./version";

export { RequestError };

/** Bearer session for native shells and the dev login; the cookie carries it on the web otherwise. */
export function sessionToken(): string | null {
  try { return localStorage.getItem("pm_token"); } catch { return null; }
}

// The same client the app uses (packages/shared/src/client.ts), on this origin with the session cookie.
export const api = createApiClient({ origin: "", token: sessionToken, credentials: "include", onVersion: noteServerVersion });

/** Human copy for API error codes (packages/shared/src/copy/errors.ts). */
export { describeError } from "@pagemates/shared/copy";
